/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */




function waitForEl(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// fetch("https://api.ipregistry.co/?key=61ky7z2r6bt11ge0")
//    .then(function (response) {
//      return response.json();
//    })
//    .then(function (payload) {
//      console.log(payload);
//      if (payload.location.country.name === "United Kingdom") {
//        window.location.href = "http://uk.inokim.com/";
//      }
//      if (
//        payload.location.country.name === "Israel" &&
//       payload.location.city !== "Ramat Gan"
//      ) {
//        window.location.href = "http://inokim.com/";
//      }
//    });

// async function getLocation() {
//   const cachedLocation = localStorage.getItem("location");
//   if (cachedLocation) {
//     return JSON.parse(cachedLocation);
//   }

//   try {
//     const response = await fetch(
//       "https://api.ipregistry.co/?key=61ky7z2r6bt11ge0"
//     );
//     const payload = await response.json();

//     localStorage.setItem("location", JSON.stringify(payload));
//     return payload;
//   } catch (error) {
//     console.error(error);
//   }
// }

//  function redirectBasedOnLocation(location) {
//    console.log(location.location.country.name);

//      switch (location.location.country.name) {
//        case "Israel":
//           window.location.href = "https://il.inokim.com/";
//          break;
//         case "United States":
//           window.location.href = "https://inokim.shop/";
//          break;
//        default:
//          break;
//      }
   
// }

//  async function main() {
//    const location = await getLocation();
//    if (location) {
//      redirectBasedOnLocation(location);
//    }
//  }

//  main();


async function getLocation() {
  const cachedLocation = localStorage.getItem("location_country");
  if (cachedLocation) {
    return cachedLocation;
  }

  try {
    const response = await fetch("https://ipapi.co/country_name/");
    const country = await response.text();
    localStorage.setItem("location_country", country.trim());
    return country.trim();
  } catch (error) {
    console.error("Location detection failed:", error);
    return null;
  }
}

function redirectBasedOnLocation(country) {
  switch (country) {
    case "Israel":
      window.location.href = "https://il.inokim.com/";
      break;
    case "United States":
      window.location.href = "https://inokim.shop/";
      break;
    default:
      break;
  }
}

async function main() {
  return; // IN27: geo-redirect disabled (2026-10-23, Kfir) - everyone lands on inokim.com; Israel/US use the Shop Israel / Shop USA links
  const country = await getLocation();
  if (country) {
    redirectBasedOnLocation(country);
  }
}

main();


const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after 10 second`));
    }, s * 1000);
  });
};

const AJAX = async function (url, uploadData = undefined, options = {}) {
  try {
    const fetchOptions = {
      method: uploadData ? "POST" : "GET",
      headers: {
        "Content-Type": "application/json",
      },
      ...options, // Spread additional options, which can override defaults
    };

    if (uploadData) fetchOptions.body = JSON.stringify(uploadData);

    const fetchPro = fetch(url, fetchOptions)
    const res = await Promise.race([fetchPro, timeout(20)]);
    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};


if (window.location.href.includes("distribution")) {
  const form = document.getElementById("contact_form");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    
    const data = new FormData(form);
    const formattedData = formatFormData(data);
   const btn = form.querySelector('.wd-form__submit'); 
     btn.disabled = true;
    formattedData.form = "contact";
      // formattedData.country = "USA";
    console.log(formattedData)
    const response = await AJAX(
      "https://dealers.inokim.com/lead/g",
      formattedData,
      { mode: 'no-cors' }
    );
     window.location.reload();
  });
}

function formatFormData(formData) {
  const siteUrl = `${window.location.protocol}//${window.location.hostname}`;
  const formattedData = { site_url: siteUrl };
  for (const [key, value] of formData.entries()) {
    if (key === "form_type" || key === "utf8") {
      continue;
    }
    let formattedKey = key;
    if (key.startsWith("contact[")) {
      formattedKey = key
        .replace("contact[", "")
        .replace("]", "")
        .replace("-", "_");
    }
    formattedData[formattedKey] = value;
  }
  return formattedData;
}

const formShip = document.getElementById('shipping_protection');

if (formShip) {
    formShip.addEventListener('submit', async (e) => {
        e.preventDefault();
      const btn =  formShip.querySelector('.wd-form__submit');
      btn.textContent='Loading...'

        const fileInput = formShip.querySelector('input[type="file"]');
        const file = fileInput.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = async function (readEvent) {
                const base64Data = readEvent.target.result;
                const dataArr = [...new FormData(formShip)];
                
                // Replace the file object in the FormData array with the Base64 string
                const fileIndex = dataArr.findIndex(item => item[0] === fileInput.name); // Use fileInput.name instead of 'contact[file]'
                if (fileIndex !== -1) {
                    dataArr[fileIndex][1] = base64Data; // Replace the file object with Base64 data
                }
                const dataObj = Object.fromEntries(dataArr);
              console.log(dataObj)
              const response = await AJAX(
                    "https://shipping-guard-25330b2be75f.herokuapp.com/api/v1/form-data",
                    dataObj
                  );

              
              formShip.reset()
              btn.textContent='SUBMIT'
              
            };

            // Read the file as Data URL (Base64 encoded)
            reader.readAsDataURL(file);
           
        } else {
            // Handle the case where no file is selected but the form is submitted
            const dataArr = [...new FormData(formShip)];
            const dataObj = Object.fromEntries(dataArr);
            console.log(dataObj); // Corrected to log dataObj

            // Assuming AJAX is a function you've previously defined for making HTTP requests
            // Handle form submission without a file
            const sendData = await AJAX('https://shipping-guard-25330b2be75f.herokuapp.com/api/v1/form-data', dataObj);
            console.log(sendData); // Log the response from AJAX call
        }
    });
}
const updateUpsellSwiper = () => {
    const upsell1 = new Swiper(".custom-upsell-swiper-slider", {
      slidesPerView: 1,
      spaceBetween: 40,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    const upsell2 = new Swiper(".custom-upsell-swiper-slider2", {
      slidesPerView: 1,
      spaceBetween: 40,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
}
const initializeBodyObservation1 = () => {
    const targetNode = document.body;
    const config = { attributes: true };
  
    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (document.body.classList.contains("hw-abt-2-1")) {
           window.dispatchEvent(new Event("resize"));
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };
 document.addEventListener("DOMContentLoaded", (event) => {
  
  document.addEventListener("DrawerCartOpened", (evt) => {
    setTimeout(updateUpsellSwiper,1000);
  });
 });








